<template lang="pug">
.crud
  modal-import(model="tasks")
  modal-tasks-detail(:form='form' :task="task" :active="isModalTaskDetailVisible" @close="closeModalTaskDetail")
  modal-tasks(:form='form', :is-add='isModalAdd')
  .container-fluid
    vm-row.heading(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        div
          h2 {{ $t('strings.tasks') }}
            img.icon(src='@/assets/icons/books.svg')
          span {{ $t('strings.description', {attribute: $t('strings.tasks')}) }}
        div(style="display:none;")
          vm-button(type="default" icon="list")
          vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
      vm-col(vm-type="flex" vm-align="center" vm-justify="end" vm-lg=6 vm-sm=6)
        div.filters-button
          vm-tooltip(:text="$t('strings.filters')" delay=".5s")
          vm-dropdown(ref="dropdown").filters
            vm-button(type="default" icon="funnel-outline" size="small") {{$t('strings.filters')}}
            vm-dropdown-menu(class="filters")
              .heading.d-flex.justify-content-between
                h4 {{ $t('strings.filters') }}
                h4 {{filters.where.end_date}}
                vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
              h5.filter {{$t('tasks.type')}}
                vm-select(autofocus :placeholder='$t("tasks.name_placeholder")'  v-model="filters.where.foliable_type" label='').vm-select-row
                  vm-select-item(v-for="item in types" :key="item.id" :text="item.name" :value="item.url")
              h5.filter(v-if="filters.where.foliable_type !== ''").filter {{$t('tasks.folio')}}
                vm-typeahead(:url="foliableType" :label="$t('')" :serializer="item => item.folio" :data="catalog[foliableType]" placeholder='S##-###-##' v-model="filters.whereIn.foliable_id" :filter="query => `?param=${query},folio`" @input-change="autoCompleteFunc").vm-select-row
                  template(slot-scope="{data}")
                    vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="[item.data.id]" v-bind:text="item.text" v-for="item,index in data")
              h5.filter(v-if="filters.where.foliable_type !== 'purchaseOrders' && filters.where.foliable_type !== ''").filter Provedores
                vm-typeahead( url="suppliers" :label="$t('')" :serializer="item => item.name" :data="catalog.suppliers" placeholder='suppliers' v-model="filters.where.supplier_id" :filter="query => `?param=${query},name`" @input-change="autoCompleteFunc").vm-select-row
                  template(slot-scope="{data}")
                    vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
              h5.filter(v-if="filters.where.foliable_type !== ''").filter Clientes
                vm-typeahead( url="customers" :label="$t('')" :serializer="item => item.tradename" :data="catalog.customers" placeholder='customers' v-model="filters.where.customer_id" :filter="query => `?param=${query},tradename`" @input-change="autoCompleteFunc").vm-select-row
                  template(slot-scope="{data}")
                    vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
              h5.filter {{$t('tasks.status')}}
                vm-select(autofocus :defaultValue="filters.where.status ? filters.where.status : status[0].text " placeholder='' v-model="filters.where.status" :label='$t("")').vm-select-row
                  vm-select-item(v-for="item in status" :key="item.id" :text="item.text" :value="item.value")
              h5.filter {{$t('strings.user')}}
                vm-typeahead(url="users" :label="$t('strings.user')" :serializer="item => item.name" :data="catalog.users" :placeholder="$t('tasks.user_placeholder')" v-model="filters.where.users.user_id" :filter="query => `?param=${query},name`" @input-change="autoCompleteFunc").vm-select-row
                  template(slot-scope="{data}")
                    vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
              h5.filter {{$t('tasks.end_date')}}
                b-form-group
                  vm-date-picker(type="daterange" label="" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.end_date")
              .filter.d-flex
                vm-button(@click="applyFilters(filters)") {{ $t('strings.apply') }}
        div
          vm-button(icon="plus" @click="addRecord").border-radius {{ $t('tasks.add') }}
          vm-tooltip(:text="$t('strings.options')" delay=".5s")
            vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
              vm-button(type="border" icon="more-horizotnal" color="#afbbc6").border-radius
              vm-dropdown-menu
                vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin')" @click="exportRecords")
                  vm-icon(icon="download-outline")
                  slot &nbsp;{{ $t('tasks.export') }}
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-table(max-height="350px" :data="tasks" )
          template(slot="header")
            .d-flex.justify-content-between
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('tasks.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                .details(v-on:click.stop="openDetail(data[indextr])")
                  slot(v-if="column == 'folio'") {{getFolio(data[indextr])}}
                  vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status_display'] !== 'Terminada'" :color="colorStatus(data[indextr]['status_display'])") {{data[indextr]['status_display']}}
                  slot(v-if="column == 'created_by'") {{data[indextr][column].name}}
                  slot(v-if="column == 'title'") {{data[indextr][column]}}
                  slot(v-if="column == 'start_date'") {{data[indextr][column] | moment('DD-MMMM-YYYY, h:mm a')}}
                  slot(v-if="column == 'end_date'") {{data[indextr][column] | moment('DD-MMMM-YYYY')}}
                  slot(v-if="column == 'users'")
                    vm-avatar(v-for="item in data[indextr][column]" :key="item.id" :text="item.name" :color="item.pivot.seen !== 1 ? 'grey' : 'primary'" :src="item.avatar").avatar-radius
              vm-td
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="editRecord(data[indextr], tr)")
                    vm-icon(icon="edit-2-outline")
                    slot &nbsp;{{ $t('strings.edit') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] !== 2" @click="setActionRecord(data[indextr], 'finishedStatus')")
                    vm-icon(icon="clock-outline")
                    slot &nbsp;{{ $t('strings.finish') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-else @click="setActionRecord(data[indextr], 'inProgressStatus')")
                    vm-icon(icon="sync-outline")
                    slot &nbsp;{{ $t('strings.resume') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="deleteTaskConfirm(data[indextr])")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
                  //- More actions
        vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
        transition(name="enter")
          .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Tasks')
const ModalImport = () => import('@/components/modals/ModalImport.vue')
const ModalTasks = () => import('@/components/modals/ModalTasks.vue')
const ModalTasksDetail = () => import('@/components/modals/ModalTasksDetail.vue')

export default {
  name: 'Tasks',
  components: {
    ModalImport,
    ModalTasks,
    ModalTasksDetail
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['users', 'created_by', 'folio', 'title', 'start_date', 'end_date', 'status'],
    columnsOrderBy: ['name', 'email'],
    attributeModal: 'name',
    isModalTaskDetailVisible: false,
    task: {},
    status: [
      {
        text: 'En Proceso',
        value: 1,
        color: 'precaution'
      },
      {
        text: 'Terminada',
        value: 2,
        color: 'success'
      }
    ],
    lastFolio: '',
    types: [
      {
        name: 'Otro',
        url: '',
        type: ''
      },
      {
        name: 'Cotizacion',
        url: 'quotations',
        type: 'App\\Quotation'
      },
      {
        name: 'Venta',
        url: 'sales',
        type: 'App\\Sale'
      },
      {
        name: 'Ordenes de Compra',
        url: 'purchaseOrders',
        type: 'App\\PurchaseOrder'
      }],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        foliable_type: '',
        end_date: '',
        customer_id: '',
        supplier_id: '',
        foliable_id: '',
        users: {
          user_id: ''
        },
        status: ''
      },
      bySell: {

      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        end_date: []
      },
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters(['tasks', 'catalog', 'pagination', 'filterParams']),
    foliableType () {
      console.log(this.filters.where.foliable_type)
      return this.filters.where.foliable_type !== undefined ? this.filters.where.foliable_type : this.types[0].url
    }
  },
  async created () {
    this.$echo && this.$echo.channel(this.pascalCaseSigular).listen('updated', (payload) => {
      this.updateRecord(payload.model)
    })
  },
  methods: {
    ...mapActions([
      'updateRecord',
      'deleteRecord',
      'deleteRecords',
      'loadRecords',
      'loadCatalog',
      'markSeenTask',
      'actionRecord',
      'setModalVisible',
      'setModalImportVisible',
      'exportRecords',
      'applyFilter',
      'loadTasks',
      'loadComments',
      'clearFilter'
    ]),
    getFolio (value) {
      return value['foliable'] ? value['foliable'].folio : 'sin folio'
    },
    formFoliableType (value) {
      let type = this.types.find(item => item.type === value).type
      this.filters.where.foliable_type = type
    },
    urlFormFoliableType (value) {
      let url = this.types.find(item => item.type === value).url
      return url
    },
    async deleteTaskConfirm (task) {
      let t = this
      this.auxDeleteRecord = () => {
        t.deleteRecord(task)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.task'), attribute: `"${task.title}"` }),
        accept: this.auxDeleteRecord
      })
    },
    addRecord () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.form = {
        assign_to_ids: [this.$auth.user()],
        file: '',
        foliable: '',
        foliable_type: ''
      }
    },
    formatForm (value) {
      let form = {
        id: value.id,
        title: value.title,
        desc: value.desc,
        start_date: value.start_date,
        end_date: value.end_date,
        assign_to_ids: value.users && value.users,
        file: value.attachments && value.attachments[0],
        created_by_id: value.created_by_id && value.created_by_id.id,
        customer_id: value.customer_id,
        supplier_id: value.supplier_id,
        foliable_id: value.foliable_id,
        foliable_type: value.foliable_type ? this.urlFormFoliableType(value.foliable_type) : ''
      }
      return form
    },
    colorStatus (status) {
      switch (status) {
        case 'En Proceso':
          return 'rgb(220, 159, 3)'
        case 'Terminada':
          return 'rgb(23, 201, 100)'
      }
    },
    parserType (value) {
      switch (value) {
        case 'App\\\\\\\\PurchaseOrder':
          return 'Orden de compra'
        case 'App\\\\\\\\Sale':
          return 'Venta'
        case 'App\\\\\\\\Quotation':
          return 'Cotizacion'
      }
    },
    applyFilters (filters) {
      if (this.filters.where.foliable_type !== '') {
        this.formFoliableType(filters.where.foliable_type)
      }
      this.applyFilter(this.filters)
      this.filters.where.foliable_type = ''
    },
    async openDetail (task) {
      this.markSeenTask(task)
      this.loadComments(task)
      this.task = task
      this.isModalTaskDetailVisible = !this.isModalTaskDetailVisible
    },
    closeModalTaskDetail () {
      this.comments = []
      this.isModalTaskDetailVisible = false
      this.task = {}
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.avatar-radius{
  border-radius: 80% !important;
  width: 36px;
  height: 36px;
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.border-radius {
  border-radius: 30px !important;
}
.filters-button {
  margin: 1px 30px 0px 10px;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
.icon {
  width: 35px;
  height: auto;
}
</style>
